export const endpoint = {
  ADMIN_ACCOUNT: {
    GUEST_CODE: "admin/account/guest/code",
    //GUEST_LOGIN: "/admin/account/guest/login",
    GUEST_LOGIN: "Login/admin/token",
    GUEST_RECOVER: {
      PASSWORD: "admin/account/guest/recover/password",
      PASSWORD_GENERIC: "admin/account/guest/recover/passwordgeneric",
    },
    GUEST_REGISTER_COMMERCIALISTA_RESP:
      "admin/account/guest/register/commercialistaresp",
    GUEST_REGISTER_OPERATOR: "/admin/account/guest/register/operator",
    LOGOUT: "/admin/account/logout",
    EMAIL: "/admin/account/email",
    PASSWORD: "/admin/account/password",
  },
  ADMIN_CATEGORIES: "/admin/categories",
  ADMIN_CATEGORIES_GETUPLOADURL: "/admin/categories/getuploadurl",
  ADMIN_DOCUMENT: {
    DOCUMENTS: "/admin/documents",
    DOCUMENTS_PENDING: "admin/documents/pending",
    DOCUMENTS_VALIDATEALL: "admin/documents/validateall",
    DOCUMENTS_REJECTALL: "/admin/documents/rejectall",
    DOCUMENTS_REANALYZE_PENDINGS: "admin/documents/reanalyzependings",
    DOCUMENTS_DELETEALL: "admin/documents/deleteall",
    DOCUMENTS_STATS: "/admin/stats/user/",
    DOCUMENTS_EXPORTZIP: "admin/documents/exportzip",
    DOCUMENTS_DUPLICATE: "/admin/documents/checkduplicate",
  },
  ADMIN_ENUM: {
    MAIN_CATEGORIES: "admin/enums/maincategories",
    IDENT_CATEGORIES: "/admin/enums/identcategories",
  },
  ADMIN_STATS: {
    NEW_DOC_STATS: "admin/Stats/pending/count",
    ADMIN_STATS: "/admin/stats",
    ADMIN_STATS_GENERIC: "/admin/stats/generic",
    ADMIN_STATS_AGGREGATEDOCS: "/admin/stats/aggregatedocs",
    ADMIN_STATS_AGGREGATEDOCS_BY_DAYS: "/admin/stats/aggregatedocsbydays",
    ADMIN_STATS_DOCS_BY_CATEGORY: "/admin/stats/docsbycategory",
  },
  ADMIN_STUDIO: {
    STUDIO: "admin/studio",
  },
  ADMIN_USERS: {
    ADMIN_USERS: "admin/users",
  },
  ADMIN_PRACTICE_SERVICE: {
    SERVICES: "admin/practiceservices/list",
  },

  ADMIN_NEWS: {
    NEWS: "admin/News",
  },

  ADMIN_CHAT: {
    CHAT: "/admin/chat/",
    NEW_CHAT: "/admin/chat/conversation",
  },

  USERS: {
    USERS: "/user",
    /* GUEST_LOGIN:  "/users/guest/login", old api */
    GUEST_LOGIN: "Login/user/token",
    GUEST_REGISTER_LITE: "/user/guest/register/lite",
    GUEST_RECOVER_PASSWORD: "/users/guest/recover/password",
  },
  USER_STATS: {
    USER_STATS: "/stats/docs",
    USER_STATS_GENERIC: "/stats/generic",
    USER_STATS_AGGREGATEDOCS: "/stats/aggregatedocs",
    USER_STATS_AGGREGATEDOCS_BY_DAYS: "/stats/aggregatedocsbydays",
    USER_STATS_DOCS_BY_CATEGORY: "/stats/docsbycategory",
  },
  USER_DOCUMENTS: {
    DOCUMENTS: "/documents",
  },
  USER_PRACTICES: {
    PRACTICES: "/practices",
  },
  USER_STUDIOS: {
    USER_STUDIOS: "/studios",
    DETAIL: "/studios/:id",
  },
  USER_DATA: {
    DATA_HOME: "/data/home",
  },
  USER_NUCLEO: {
    FAMILY: "/user/details/familymembers",
    CHILDREN: "/user/details/children",
  },
  USER_CHAT: {
    CHAT: "/chat",
    NEW_CHAT: "chat/conversation",
  },
  USER_CALENDAR: {
    CALENDAR: "/calendar/taxdeadline",
  },
};
